import { render } from "./DescriptionGenerationStep.vue?vue&type=template&id=2955155f"
import script from "./DescriptionGenerationStep.vue?vue&type=script&lang=js"
export * from "./DescriptionGenerationStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__